import axios from "axios";
import axiosInstance from "../core/axios";
import { apiEndPoints } from "../variables/apiEndpoints";

export const loginUser = async (email: string, password: string) => {
  const passwordHash = btoa(password);
  try {
    const response = await axiosInstance.post(`${apiEndPoints.login}`, {
      email,
      password: passwordHash,
    });
    return response;
  } catch (err) {
    throw err;
  }
};

export const forgotPassword = async (email: string) => {
  try {
    const response = await axiosInstance.post(
      `${apiEndPoints.forgotPassword}`,
      `"${email}"`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const resetPassword = async (password: string, token: string) => {
  const passwordHash = btoa(password);
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}${apiEndPoints.resetPassword}`,
      `"${passwordHash}"`,
      {
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const changePassword = async () => {
  try {
    await axiosInstance.post(`${apiEndPoints.changePassword}`);
  } catch (err) {
    throw err;
  }
};

export const logoutUser = async () => {
  try {
    await axiosInstance.post(`${apiEndPoints.logout}`);
  } catch (err) {
    throw err;
  }
};
